import { useState, useCallback } from 'react'
import { getData } from '../api/apiService'
import { processLocation } from '../utils/location-utils'

// Custom hook for managing pop-up state
// Accepts customHeaders and passes them to getData
const usePopup = (customHeaders = {}) => {
  const [isPopupOpen, setPopupOpen] = useState(false)
  const [popupDetails, setPopupDetails] = useState(null)
  const [popupLoading, setPopupLoading] = useState(false)
  const [spatialExtent, setSpatialExtent] = useState(null)

  // Function to open the pop-up with API call
  const handleOpenPopup = useCallback(
    async (details) => {
      try {
        setPopupLoading(true)
        let directory = processLocation(details.location_name)
        
        // Make both API calls in parallel
        const [filesResponse, spatialResponse] = await Promise.all([
          getData(`/files/info/${directory}`, customHeaders),
          getData(`/spatial/info/${details.tdis_identifier}`, customHeaders)
        ])

        details.files = filesResponse
        setSpatialExtent(spatialResponse)
        setPopupOpen(true)
        setPopupDetails(details)
      } catch (error) {
        console.error('Error opening pop-up:', error)
      } finally {
        setPopupLoading(false)
      }
    },
    [customHeaders]
  )

  // Function to close the pop-up
  const handleClosePopup = useCallback(() => {
    setPopupOpen(false)
    setPopupDetails(null)
    setSpatialExtent(null)
  }, [])

  return {
    isPopupOpen,
    popupDetails,
    handleOpenPopup,
    handleClosePopup,
    popupLoading,
    spatialExtent
  }
}

export default usePopup
